import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createIndividualConsultationScheduleItem, updateIndividualConsultationScheduleItem, fetchIndividualConsultationScheduleItem } from './actions';
import IndividualConsultationScheduleSettingsForm from './SettingsForm';
import authUtils from '../../auth/utils';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class Details extends Component {

	constructor(props) {
		super(props);
		this.handleIndividualConsultationScheduleGenerateSubmit = this.handleIndividualConsultationScheduleGenerateSubmit.bind(this);
		this.handleRecurranceTypeChange = this.handleRecurranceTypeChange.bind(this);
		this.initializeRecurrenceType = false;
		this.state = { recurrenceType: 0 };
	}

	componentDidMount() {
		const { match, fetchIndividualConsultationScheduleItem } = this.props;
		const individualConsultationScheduleItemId = match.params.id;
		if (individualConsultationScheduleItemId) {
			fetchIndividualConsultationScheduleItem(individualConsultationScheduleItemId);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.individualConsultationScheduleItem && !this.initializeRecurrenceType) {
			this.initializeRecurrenceType = true;
			this.setState({ recurrenceType: nextProps.individualConsultationScheduleItem.recurrenceType });
		}
	}

	handleIndividualConsultationScheduleGenerateSubmit(values) {
		const {
			history, createIndividualConsultationScheduleItem,
			updateIndividualConsultationScheduleItem, individualConsultationScheduleItem
		} = this.props;

		const fields = this.fieldsByReccurenceType(values);

		if (individualConsultationScheduleItem) {
			updateIndividualConsultationScheduleItem(
				individualConsultationScheduleItem.id,
				fields,
				history
			);
		} else {
			createIndividualConsultationScheduleItem(fields, history);
		}

	}

	fieldsByReccurenceType(values) {
		const {
			recurrenceType, centerId,
			startDate, endDate, startTime, endTime, daysOfWeek
		} = values;

		if (recurrenceType == 0) {	// none
			return {
				centerId,
				recurrenceType,
				startDate,
				endDate: startDate,
				startTime,
				endTime
			};
		} else if (recurrenceType == 2) {	// weekly
			const daysOfWeekBitwise = daysOfWeek
				.map(entry => entry.value)
				.reduce((accumulator, currentValue) => accumulator | currentValue);
			return {
				centerId,
				recurrenceType,
				startDate,
				endDate,
				startTime,
				endTime,
				daysOfWeek: daysOfWeekBitwise
			};
		}

		return {};
	}

	handleRecurranceTypeChange(event, recurrenceType) {
		this.setState({ recurrenceType });
	}

	prepareDaysOfWeek(recurrenceDaysOfWeek) {
		if (!recurrenceDaysOfWeek) {
			return [];
		}

		return Object.keys(recurrenceDaysOfWeek)
			.map(id => {
				const entry = recurrenceDaysOfWeek[id];
				return { value: entry.id, label: entry.displayName };
			});
	}

	render() {
		const { recurrenceTypes, individualConsultationScheduleItem, isReadonly, match, t } = this.props;
		const { recurrenceType } = this.state;
		const recurrenceDaysOfWeek = this.prepareDaysOfWeek(this.props.recurrenceDaysOfWeek);
		const individualConsultationScheduleItemId = match.params.id;

		const commonProps = {
			onSubmit: this.handleIndividualConsultationScheduleGenerateSubmit,
			recurrenceTypes,
			recurrenceType,
			onRecurranceTypeChange: this.handleRecurranceTypeChange,
			daysOfWeek: recurrenceDaysOfWeek,
			isReadonly

		};

		if (individualConsultationScheduleItemId) {
			let initialValues = undefined;
			if (individualConsultationScheduleItem) {
				initialValues = {
					...individualConsultationScheduleItem,
					centerId: individualConsultationScheduleItem.center.id,
					daysOfWeek: this.prepareDaysOfWeek(individualConsultationScheduleItem.daysOfWeek)
				};
			}

			return <Panel>
				<Panel.Heading>{t('Common_Details')}</Panel.Heading>
				<Panel.Body>
					<IndividualConsultationScheduleSettingsForm
						initialValues={initialValues}
						{...commonProps}
					/>
				</Panel.Body>
			</Panel>;
		}

		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				<IndividualConsultationScheduleSettingsForm
					initialValues={{ recurrenceType }}
					{...commonProps}
				/>
			</Panel.Body>
		</Panel>;
	}

}

const mapStateToProps = (state, ownProps) => {
	const id = ownProps.match.params.id;

	const {
		entities: { individualConsultationScheduleItems },
		auth: { currentUser },
		lookups: { individualConsultationScheduleRecurrenceTypes, recurrenceDaysOfWeek }

	} = state;

	return {
		currentUser,
		individualConsultationScheduleItem: individualConsultationScheduleItems[id],
		recurrenceTypes: individualConsultationScheduleRecurrenceTypes,
		recurrenceDaysOfWeek,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'IndividualConsultationsSchedule')
	};
};

const mapDispatchToProps = {
	createIndividualConsultationScheduleItem,
	updateIndividualConsultationScheduleItem,
	fetchIndividualConsultationScheduleItem
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Details));